import { useState, useEffect } from "react";
import {
  Button,
  Box,
  TextField,
  CardMedia,
  Typography,
  FormControlLabel,
  Checkbox,
  Card,
  Avatar,
} from "@mui/material";
import { UseWriters } from "./UseWriters";
import { useNavigate, useLocation } from "react-router-dom";
import ProgressCom from "../../components/ProgressCom";
import Detail from "../../main/detail/Detail";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import Editor from "ckeditor5-custom-build/build/ckeditor";
import { rsProgress, rsActiveMenu, rsGotoLast } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import { FileUploader } from "react-drag-drop-files";
import useBreakpoints from "../../hooks/useBreakpoints";

export default function EditWriter() {
  const fileTypes = [
    "JPG",
    "jpeg",
    "jfif",
    "pjpeg",
    "pjp",
    "PNG",
    "SVG",
    "webp",
    "GIF",
  ];
  const [msGotoLast, setMsGotoLast] = useRecoilState(rsGotoLast);
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const [progress, setProgress] = useRecoilState(rsProgress);
  const navigate = useNavigate();
  const location = useLocation();
  const [brand, setBrand] = useState();
  const { GetWriterByID, validate, UpdateWriter } = UseWriters();
  const [valueStart, setValueStart] = useState();
  const [state, setState] = useState({
    id: undefined,
    author: undefined,
    isGuest: false,
    authorSUM: undefined,
    biography: undefined,
    orderRow: undefined,
  });
  const exceptThisSymbols = ["e", "E", "+", "-", "."];
  const [imgState, setImgState] = useState({
    fileAvatar: undefined,
    urlAvatar: state.icon ? state.icon : "",
    fileBackground: undefined,
    urlBackground: state.icon ? state.icon : "",
  });
  const { isSmall } = useBreakpoints();

  useEffect(() => {
    if (location.state) {
      setProgress(true);
      GetWriterByID(location.state.id, (callback) => {
        setImgState({
          urlAvatar: callback.avatar ? callback.avatar : "",
          urlBackground: callback.background ? callback.background : "",
        });
        setState({
          id: callback.id,
          author: callback.author,
          isGuest: callback.isGuest,
          authorSUM: callback.authorSUM,
          biography: callback.biography,
          orderRow: callback.orderRow,
        });
      });
    }
  }, [location.state]);

  const [errorState, setErrorState] = useState({
    author: false,
  });

  const handleChangeAvatar = (file) => {
    setImgState({
      ...imgState,
      fileAvatar: file.target.files[0],
      urlAvatar: URL.createObjectURL(file.target.files[0]),
    });
  };

  const handleChangeBackground = (file) => {
    setImgState({
      ...imgState,
      fileBackground: file.target.files[0],
      urlBackground: URL.createObjectURL(file.target.files[0]),
    });
  };

  return (
    <Detail
      breadChilds={{
        title: "مدیریت محتوا",
        childs: [
          { name: msActiveMenu.pageTitle, url: "/authors" },
          {
            name: "ویرایش نویسنده",
            url: "/authors/editAuthors",
          },
        ],
      }}
    >
      {!brand ? (
        <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={3}>
          <Box gridColumn={isSmall ? "span 12" : "span 5"}>
            <TextField
              fullWidth
              value={state.author ? state.author : ""}
              error={errorState.author}
              label="نام نویسنده"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, author: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 7"></Box>}
          <Box
            gridColumn={isSmall ? "span 12" : "span 10"}
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              flexDirection: isSmall ? "column" : "row",
              alignItems: isSmall ? "flex-start" : "center",
              gap: 5,
            }}
          >
            <Box component="label">
              <Avatar
                sx={{
                  border: "1px solid #d9d9d9",
                  borderRadius: 3,
                  width: "150px",
                  height: "150px",
                  p: 1,
                }}
                src={
                  imgState.urlAvatar
                    ? imgState.urlAvatar
                    : "/static/img/nobanner.png"
                }
                alt="img"
              />
              <input
                type="file"
                id="img"
                name="avatarName"
                accept="image/*"
                multiple
                onChange={handleChangeAvatar}
                hidden
              />
            </Box>
            <Box component="label">
              <Avatar
                sx={{
                  border: "1px solid #d9d9d9",
                  borderRadius: 3,
                  width: "350px",
                  height: "150px",
                  p: 1,
                }}
                src={
                  imgState.urlBackground
                    ? imgState.urlBackground
                    : "/static/img/nobanner.jpg"
                }
                alt="img"
              />
              <input
                type="file"
                id="img"
                name="avatarName"
                accept="image/*"
                multiple
                onChange={handleChangeBackground}
                hidden
              />
            </Box>
          </Box>
          {!isSmall && <Box gridColumn="span 2"></Box>}
          <Box gridColumn={isSmall ? "span 6" : "span 2"}>
            <TextField
              fullWidth
              value={state.orderRow ? state.orderRow : ""}
              label="ردیف"
              size="small"
              variant="outlined"
              type="number"
              onKeyDown={(e) =>
                exceptThisSymbols.includes(e.key) && e.preventDefault()
              }
              onChange={(evt) => {
                setState({ ...state, orderRow: evt.target.value });
              }}
              InputProps={{
                autoComplete: "off",
                inputProps: {
                  min: 1,
                },
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 10"></Box>}
          <Box gridColumn="span 12" gridRow={isSmall ? "span 12" : "span 2"}>
            <Typography sx={{ mb: 1 }} color="secondary" variant="subtitle1">
              بیوگرافی :{" "}
            </Typography>
            <Box className="fullCk">
              {state.id !== "" && (
                <CKEditor
                  config={{
                    language: "fa",
                    link: {
                      decorators: {
                        addTargetToExternalLinks: {
                          mode: "automatic",
                          callback: (url) => /^(https?:)?\/\//.test(url),
                          attributes: {
                            target: "_blank",
                            rel: "noopener noreferrer",
                          },
                        },
                      },
                    },
                  }}
                  editor={Editor}
                  data={state.biography ? state.biography : ""}
                  onChange={(event, editor) => {
                    const data = editor.getData();
                    if (state.id) {
                      setState({ ...state, biography: data });
                    }
                  }}
                  onReady={(editor) => {
                    editor.editing.view.change((writer) => {
                      writer.setStyle(
                        "height",
                        "300px",
                        editor.editing.view.document.getRoot()
                      );
                    });
                  }}
                />
              )}
            </Box>
          </Box>
          <Box gridColumn="span 12" gridRow={isSmall ? "span 12" : "span 2"}>
            <Typography sx={{ mb: 1 }} color="secondary" variant="subtitle1">
              خلاصه نویسنده :{" "}
            </Typography>
            <Box className="fullCk">
              {state.id !== "" && (
                <CKEditor
                  config={{
                    language: "fa",
                    link: {
                      decorators: {
                        addTargetToExternalLinks: {
                          mode: "automatic",
                          callback: (url) => /^(https?:)?\/\//.test(url),
                          attributes: {
                            target: "_blank",
                            rel: "noopener noreferrer",
                          },
                        },
                      },
                    },
                  }}
                  editor={Editor}
                  data={state.authorSUM ? state.authorSUM : ""}
                  onChange={(event, editor) => {
                    const data = editor.getData();
                    if (state.id) {
                      setState({ ...state, authorSUM: data });
                    }
                  }}
                  onReady={(editor) => {
                    editor.editing.view.change((writer) => {
                      writer.setStyle(
                        "height",
                        "150px",
                        editor.editing.view.document.getRoot()
                      );
                    });
                  }}
                />
              )}
            </Box>
          </Box>
          <Box gridColumn={isSmall ? "span 12" : "span 4"}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={state.isGuest}
                  onChange={(event) =>
                    setState({
                      ...state,
                      isGuest: event.target.checked,
                    })
                  }
                />
              }
              label="نویسنده مهمان شود"
            />
          </Box>
          <Box gridColumn="span 12">
            <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
              <Box>
                <Button
                  sx={{ mr: 2, width: "100px" }}
                  variant="contained"
                  color="secondary"
                  onClick={() => {
                    if (validate(state, setErrorState) == 200) {
                      setProgress(true);
                      UpdateWriter(
                        state,
                        imgState.fileAvatar,
                        imgState.fileBackground,
                        () => {
                          setMsGotoLast(true);
                          navigate("/authors", {
                            state: { ...location.state, isBack: true },
                            replace: true,
                          });
                        }
                      );
                    }
                  }}
                >
                  ثبت
                </Button>
              </Box>
              <Box>
                <Button
                  sx={{ width: "100px" }}
                  variant="outlined"
                  color="secondary"
                  onClick={() => {
                    navigate("/authors", {
                      state: { ...location.state, isBack: true },
                      replace: true,
                    });
                  }}
                >
                  بازگشت
                </Button>
              </Box>
            </Box>
          </Box>
        </Box>
      ) : (
        <ProgressCom></ProgressCom>
      )}
    </Detail>
  );
}
